'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import { callIfPossible } from '../core/Functions';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import UIIconButton from '../button/UIIconButton';
import UIDragHandle from './UIDragHandle';
import UIIcon from '../icon/UIIcon';
import UITooltip from '../tooltip/UITooltip';
import { FieldsetContextConsumer } from '../context/FieldsetContext';

const renderDraggable = (connectDragSource, DragHandle, fieldsetContext) => {
  const dragHandle = /*#__PURE__*/_jsx("span", {
    className: "private-movable-group__grippie"
  });

  const dragSource = callIfPossible(connectDragSource, dragHandle) || dragHandle;
  return /*#__PURE__*/_jsx(DragHandle, {
    size: fieldsetContext.size === 'small' ? 'small' : undefined,
    children: dragSource
  });
};

export default class UIMoveableGroup extends Component {
  render() {
    const _this$props = this.props,
          {
      children,
      className,
      closeable,
      CloseButton,
      closeButtonProps,
      closeButtonTooltip,
      connectDragPreview,
      connectDragSource,
      connectDropTarget,
      draggable,
      DragHandle,
      onClose
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["children", "className", "closeable", "CloseButton", "closeButtonProps", "closeButtonTooltip", "connectDragPreview", "connectDragSource", "connectDropTarget", "draggable", "DragHandle", "onClose"]);

    return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
      children: fieldsetContext => {
        const group = /*#__PURE__*/_jsxs("div", Object.assign({}, rest, {
          className: classNames('private-moveable-group', className),
          children: [draggable && renderDraggable(connectDragSource, DragHandle, fieldsetContext), /*#__PURE__*/_jsx("div", {
            className: "private-moveable-group__inner has--horizontal-spacing",
            children: children
          }), closeable && /*#__PURE__*/_jsx(UITooltip, {
            title: closeButtonTooltip,
            children: /*#__PURE__*/_jsx(CloseButton, Object.assign({
              className: "private-moveable-group__close",
              onClick: onClose,
              use: "transparent"
            }, closeButtonProps, {
              children: /*#__PURE__*/_jsx(UIIcon, {
                name: "delete"
              })
            }))
          })]
        }));

        const preview = callIfPossible(connectDragPreview, group) || group;
        return callIfPossible(connectDropTarget, preview) || preview;
      }
    });
  }

}
UIMoveableGroup.propTypes = {
  children: PropTypes.node,
  closeable: PropTypes.bool.isRequired,
  CloseButton: PropTypes.elementType.isRequired,
  closeButtonProps: PropTypes.object,
  closeButtonTooltip: UITooltip.propTypes.title,
  draggable: PropTypes.bool.isRequired,
  DragHandle: getComponentPropType(UIDragHandle).isRequired,
  onClose: PropTypes.func,
  connectDragSource: PropTypes.func,
  connectDropTarget: PropTypes.func,
  connectDragPreview: PropTypes.func
};
UIMoveableGroup.defaultProps = {
  closeable: false,
  CloseButton: UIIconButton,
  draggable: true,
  DragHandle: UIDragHandle
};
UIMoveableGroup.displayName = 'UIMoveableGroup';